//
//
//
//
//
//
//
//
//
//
//

import TQ from '@/utils/tianqi';
import HMedia from '../Media';

export default {
  components: { HMedia },
  props: {
    data: {
      type: Array,
      default: (() => []),
    }
  },
  methods: {
    clickHandle({ type, url, videourl }) {
      let buttonName;
      const businessInfo = {
        citytype: this.$store.state.user.tianqiParams.citytype
      };
      if (type === 1) {
        buttonName = 'pic_click_usergrowth';
        businessInfo.url = url;
      } else if (type === 2) {
        buttonName = 'video_click_usergrowth';
        businessInfo.videourl = videourl;
      }
      TQ.clickButton({
        pageId: 'mask_usergrowth_power_alipay',
        buttonName,
        categoryId: 'switchpower',
        businessInfo
      });
    }
  },
};
